import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const READ_ONLY_STATUSES = ['completed', 'archived'];

export const isSiteReadOnlyStatus = (status) => READ_ONLY_STATUSES.includes(status);

/**
 * Fetches a site's current status and returns whether it is read-only.
 * Pass a known status via `initialStatus` (e.g. from an already-fetched
 * site record) to skip the network round-trip.
 */
export default function useSiteReadOnly(siteId, initialStatus) {
  const [status, setStatus] = useState(initialStatus || null);
  const [loading, setLoading] = useState(!initialStatus && !!siteId);

  useEffect(() => {
    if (initialStatus) {
      setStatus(initialStatus);
      setLoading(false);
      return;
    }
    if (!siteId) {
      setStatus(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      const { data } = await supabase
        ?.from('sites')
        ?.select('status')
        ?.eq('id', siteId)
        ?.maybeSingle();
      if (!cancelled) {
        setStatus(data?.status || null);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [siteId, initialStatus]);

  return {
    status,
    loading,
    isReadOnly: isSiteReadOnlyStatus(status),
  };
}
